// import React, { useState, useMemo, useEffect } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   TextField,
//   Box,
//   Typography,
//   IconButton,
//   TableSortLabel,
//   Chip,
//   Select,
//   MenuItem,
//   FormControl,
//   CircularProgress,
//   Alert,
//   Pagination,
//   Snackbar,
//   InputAdornment,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Button,
//   Tooltip,
// } from "@mui/material";
// import {
//   Search,
//   ArrowUpward,
//   ArrowDownward,
//   Refresh,
//   Delete,
// } from "@mui/icons-material";

// const API_BASE_URL = `${process.env.REACT_APP_SUPERADMIN_APP_API_BASE_URL}/api`;

// const DataTable = ({ sidebarOpen = true }) => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortOrder, setSortOrder] = useState("desc");
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     totalPages: 1,
//     totalItems: 0,
//     itemsPerPage: 10,
//   });
//   const [updateLoading, setUpdateLoading] = useState({});
//   const [deleteLoading, setDeleteLoading] = useState({});
//   const [deleteDialog, setDeleteDialog] = useState({
//     open: false,
//     submissionId: null,
//     submissionName: "",
//   });
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   // Fetch data from API
//   const fetchData = async (page = 1, search = "", limit = 10) => {
//     try {
//       setLoading(true);
//       setError(null);

//       const queryParams = new URLSearchParams({
//         page: page.toString(),
//         limit: limit.toString(),
//         ...(search && { search }),
//       });

//       const response = await fetch(
//         `${API_BASE_URL}/contact-submissions?${queryParams}`
//       );

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const result = await response.json();

//       if (result.success) {
//         setData(result.data.submissions);
//         setPagination(result.data.pagination);
//       } else {
//         throw new Error("Failed to fetch data");
//       }
//     } catch (err) {
//       console.error("Error fetching data:", err);
//       setError(`Failed to load data: ${err.message}`);
//       setData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Update contact submission
//   const updateContactSubmission = async (id, updates) => {
//     try {
//       setUpdateLoading((prev) => ({ ...prev, [id]: true }));

//       const response = await fetch(
//         `${API_BASE_URL}/contact-submissions/${id}`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(updates),
//         }
//       );

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const result = await response.json();

//       if (result.success) {
//         // Update local state
//         setData((prevData) =>
//           prevData.map((item) =>
//             item._id === id ? { ...item, ...updates } : item
//           )
//         );

//         setSnackbar({
//           open: true,
//           message: "Updated successfully",
//           severity: "success",
//         });
//       } else {
//         throw new Error(result.message || "Failed to update");
//       }
//     } catch (err) {
//       console.error("Error updating contact submission:", err);
//       setSnackbar({
//         open: true,
//         message: `Update failed: ${err.message}`,
//         severity: "error",
//       });
//     } finally {
//       setUpdateLoading((prev) => ({ ...prev, [id]: false }));
//     }
//   };

//   // Delete contact submission
//   const deleteContactSubmission = async (id) => {
//     try {
//       setDeleteLoading((prev) => ({ ...prev, [id]: true }));

//       const response = await fetch(
//         `${API_BASE_URL}/contact-submissions/${id}`,
//         {
//           method: "DELETE",
//         }
//       );

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const result = await response.json();

//       if (result.success) {
//         // Remove from local state
//         setData((prevData) => prevData.filter((item) => item._id !== id));

//         // Update pagination
//         setPagination((prev) => ({
//           ...prev,
//           totalItems: prev.totalItems - 1,
//         }));

//         setSnackbar({
//           open: true,
//           message: "Contact submission deleted successfully",
//           severity: "success",
//         });

//         // If current page becomes empty, go to previous page
//         if (data.length === 1 && pagination.currentPage > 1) {
//           fetchData(
//             pagination.currentPage - 1,
//             searchTerm,
//             pagination.itemsPerPage
//           );
//         }
//       } else {
//         throw new Error(result.message || "Failed to delete");
//       }
//     } catch (err) {
//       console.error("Error deleting contact submission:", err);
//       setSnackbar({
//         open: true,
//         message: `Delete failed: ${err.message}`,
//         severity: "error",
//       });
//     } finally {
//       setDeleteLoading((prev) => ({ ...prev, [id]: false }));
//       setDeleteDialog({ open: false, submissionId: null, submissionName: "" });
//     }
//   };

//   // Handle delete click
//   const handleDeleteClick = (id, name) => {
//     setDeleteDialog({
//       open: true,
//       submissionId: id,
//       submissionName: name,
//     });
//   };

//   // Handle delete confirm
//   const handleDeleteConfirm = () => {
//     if (deleteDialog.submissionId) {
//       deleteContactSubmission(deleteDialog.submissionId);
//     }
//   };

//   // Handle delete cancel
//   const handleDeleteCancel = () => {
//     setDeleteDialog({ open: false, submissionId: null, submissionName: "" });
//   };

//   // Initial data load
//   useEffect(() => {
//     fetchData();
//   }, []);

//   // Handle search with debounce
//   useEffect(() => {
//     const timeoutId = setTimeout(() => {
//       fetchData(1, searchTerm, pagination.itemsPerPage);
//     }, 500);

//     return () => clearTimeout(timeoutId);
//   }, [searchTerm]);

//   // Handle page change
//   const handlePageChange = (event, newPage) => {
//     fetchData(newPage, searchTerm, pagination.itemsPerPage);
//   };

//   // Handle refresh
//   const handleRefresh = () => {
//     fetchData(pagination.currentPage, searchTerm, pagination.itemsPerPage);
//   };

//   // Handle status change with API call
//   const handleStatusChange = async (id, newStatus) => {
//     await updateContactSubmission(id, { status: newStatus });
//   };

//   // Handle notes change with API call (debounced)
//   const handleNotesChange = (id, newNotes) => {
//     // Update local state immediately for better UX
//     setData((prevData) =>
//       prevData.map((item) =>
//         item._id === id ? { ...item, notes: newNotes } : item
//       )
//     );

//     // Debounce API call
//     clearTimeout(window[`notesTimeout_${id}`]);
//     window[`notesTimeout_${id}`] = setTimeout(() => {
//       updateContactSubmission(id, { notes: newNotes });
//     }, 1000); // 1 second delay
//   };

//   // Sort data locally
//   const sortedData = useMemo(() => {
//     return [...data].sort((a, b) => {
//       const dateA = new Date(a.submittedAt || a.createdAt);
//       const dateB = new Date(b.submittedAt || b.createdAt);

//       if (sortOrder === "asc") {
//         return dateA - dateB;
//       } else {
//         return dateB - dateA;
//       }
//     });
//   }, [data, sortOrder]);

//   const handleSortChange = () => {
//     setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });
//   };

//   // Get color for open roles chip
//   const getOpenRolesColor = (roles) => {
//     if (roles?.includes("50+")) return "error";
//     if (roles?.includes("16-50")) return "warning";
//     if (roles?.includes("6-15")) return "info";
//     return "default";
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar((prev) => ({ ...prev, open: false }));
//   };

//   // Calculate sidebar width based on state
//   const sidebarWidth = sidebarOpen ? 220 : 100;

//   if (loading && data.length === 0) {
//     return (
//       <Box
//         sx={{
//           p: 4,
//           ml: {
//             xs: "0px",
//             sm: "0px",
//             md: `${sidebarWidth}px`,
//             xl: `${sidebarWidth}px`,
//           },
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <Box
//       sx={{
//         p: 4,
//         backgroundColor: "#fafafa",
//         minHeight: "100vh",
//         ml: {
//           xs: "0px",
//           sm: "0px",
//           md: `${sidebarWidth}px`,
//           xl: `${sidebarWidth}px`,
//         },
//         transition: "margin-left 0.3s ease",
//         fontFamily: "Outfit",
//       }}
//     >
//       {/* Header */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 4,
//         }}
//       >
//         <Typography
//           variant="h4"
//           sx={{
//             color: "#9048FB",
//             fontWeight: 600,
//             fontFamily: "Outfit",
//           }}
//         >
//           Contact Submissions
//         </Typography>
//         <IconButton
//           onClick={handleRefresh}
//           disabled={loading}
//           sx={{
//             bgcolor: "#9048FB",
//             color: "white",
//             "&:hover": { bgcolor: "#7c3aed" },
//           }}
//         >
//           <Refresh />
//         </IconButton>
//       </Box>

//       {/* Error Alert */}
//       {error && (
//         <Alert severity="error" sx={{ mb: 3 }}>
//           {error}
//         </Alert>
//       )}

//       {/* Search and Sort Controls */}
//       <Box
//         sx={{
//           display: "flex",
//           gap: 2,
//           mb: 3,
//           alignItems: "center",
//           flexDirection: { xs: "column", sm: "row" },
//         }}
//       >
//         <TextField
//           variant="outlined"
//           placeholder="Search by name, email, or company..."
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           disabled={loading}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <Search />
//               </InputAdornment>
//             ),
//           }}
//           sx={{
//             flexGrow: 1,
//             maxWidth: 400,
//             backgroundColor: "white",
//             "& .MuiInputBase-input": {
//               fontFamily: "Outfit",
//               fontSize: "16px",
//             },
//           }}
//         />

//         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//           <Typography
//             variant="body2"
//             color="text.secondary"
//             sx={{ fontFamily: "Outfit" }}
//           >
//             Sort:
//           </Typography>
//           <IconButton
//             onClick={handleSortChange}
//             sx={{
//               bgcolor: "#9048FB",
//               color: "white",
//               "&:hover": { bgcolor: "#7c3aed" },
//             }}
//           >
//             {sortOrder === "desc" ? <ArrowDownward /> : <ArrowUpward />}
//           </IconButton>
//           <Typography
//             variant="body2"
//             color="text.secondary"
//             sx={{ fontFamily: "Outfit" }}
//           >
//             {sortOrder === "desc" ? "Newest" : "Oldest"}
//           </Typography>
//         </Box>
//       </Box>

//       {/* Data Table */}
//       <Paper sx={{ overflow: "hidden", boxShadow: 2 }}>
//         <TableContainer
//           sx={{
//             position: "relative",
//             maxHeight: 700,
//             overflow: "auto",
//             "&::-webkit-scrollbar": {
//               width: "8px",
//             },
//             "&::-webkit-scrollbar-track": {
//               background: "#f1f1f1",
//             },
//             "&::-webkit-scrollbar-thumb": {
//               background: "#c1c1c1",
//               borderRadius: "4px",
//             },
//             "&::-webkit-scrollbar-thumb:hover": {
//               background: "#a1a1a1",
//             },
//           }}
//         >
//           {loading && (
//             <Box
//               sx={{
//                 position: "absolute",
//                 top: 0,
//                 left: 0,
//                 right: 0,
//                 bottom: 0,
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 bgcolor: "rgba(255, 255, 255, 0.8)",
//                 zIndex: 1,
//               }}
//             >
//               <CircularProgress />
//             </Box>
//           )}

//           <Table sx={{ minWidth: 1200 }}>
//             <TableHead sx={{ bgcolor: "#9048FB" }}>
//               <TableRow>
//                 <TableCell
//                   sx={{
//                     color: "white",
//                     fontWeight: 600,
//                     fontFamily: "Outfit",
//                     fontSize: "16px",
//                     minWidth: 120,
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   Full Name
//                 </TableCell>
//                 <TableCell
//                   sx={{
//                     color: "white",
//                     fontWeight: 600,
//                     fontFamily: "Outfit",
//                     fontSize: "16px",
//                     minWidth: 180,
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   Work Email
//                 </TableCell>
//                 <TableCell
//                   sx={{
//                     color: "white",
//                     fontWeight: 600,
//                     fontFamily: "Outfit",
//                     fontSize: "16px",
//                     minWidth: 140,
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   Company Name
//                 </TableCell>
//                 <TableCell
//                   sx={{
//                     color: "white",
//                     fontWeight: 600,
//                     fontFamily: "Outfit",
//                     fontSize: "16px",
//                     minWidth: 140,
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   Open Roles
//                 </TableCell>
//                 <TableCell
//                   sx={{
//                     color: "white",
//                     fontWeight: 600,
//                     fontFamily: "Outfit",
//                     fontSize: "16px",
//                     minWidth: 160,
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   Heard About
//                 </TableCell>
//                 <TableCell
//                   sx={{
//                     color: "white",
//                     fontWeight: 600,
//                     fontFamily: "Outfit",
//                     fontSize: "16px",
//                     minWidth: 200,
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   Message
//                 </TableCell>
//                 <TableCell
//                   sx={{
//                     color: "white",
//                     fontWeight: 600,
//                     fontFamily: "Outfit",
//                     fontSize: "16px",
//                     minWidth: 120,
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   Status
//                 </TableCell>
//                 <TableCell
//                   sx={{
//                     color: "white",
//                     fontWeight: 600,
//                     minWidth: 180,
//                     fontFamily: "Outfit",
//                     fontSize: "16px",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   Notes
//                 </TableCell>
//                 <TableCell
//                   sx={{
//                     color: "white",
//                     fontWeight: 600,
//                     fontFamily: "Outfit",
//                     fontSize: "16px",
//                     minWidth: 120,
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   <TableSortLabel
//                     active={true}
//                     direction={sortOrder}
//                     onClick={handleSortChange}
//                     sx={{
//                       color: "white !important",
//                       fontFamily: "Outfit",
//                       "& .MuiTableSortLabel-icon": {
//                         color: "white !important",
//                       },
//                     }}
//                   >
//                     Date
//                   </TableSortLabel>
//                 </TableCell>
//                 <TableCell
//                   sx={{
//                     color: "white",
//                     fontWeight: 600,
//                     fontFamily: "Outfit",
//                     fontSize: "16px",
//                     minWidth: 80,
//                     whiteSpace: "nowrap",
//                     textAlign: "center",
//                   }}
//                 >
//                   Actions
//                 </TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {sortedData.length === 0 ? (
//                 <TableRow>
//                   <TableCell
//                     colSpan={10}
//                     sx={{
//                       textAlign: "center",
//                       py: 4,
//                       color: "text.secondary",
//                       fontFamily: "Outfit",
//                       fontSize: "16px",
//                     }}
//                   >
//                     {searchTerm ? "No results found" : "No data available"}
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 sortedData.map((row) => (
//                   <TableRow
//                     key={row._id}
//                     sx={{
//                       "&:nth-of-type(even)": {
//                         bgcolor: "#f5f5f5",
//                       },
//                       "&:hover": {
//                         bgcolor: "#f3f0ff",
//                       },
//                     }}
//                   >
//                     <TableCell
//                       sx={{
//                         fontWeight: 500,
//                         fontFamily: "Outfit",
//                         fontSize: "16px",
//                       }}
//                     >
//                       {row.fullName}
//                     </TableCell>
//                     <TableCell
//                       sx={{
//                         color: "#9048FB",
//                         fontFamily: "Outfit",
//                         fontSize: "16px",
//                       }}
//                     >
//                       {row.workEmail}
//                     </TableCell>
//                     <TableCell
//                       sx={{
//                         fontFamily: "Outfit",
//                         fontSize: "16px",
//                       }}
//                     >
//                       {row.companyName}
//                     </TableCell>
//                     <TableCell>
//                       <Chip
//                         label={row.openRoles}
//                         size="small"
//                         color={getOpenRolesColor(row.openRoles)}
//                         sx={{
//                           fontFamily: "Outfit",
//                           fontSize: "14px",
//                           backgroundColor: "#9048FB",
//                           color: "#fff",
//                         }}
//                       />
//                     </TableCell>
//                     <TableCell
//                       sx={{
//                         fontFamily: "Outfit",
//                         fontSize: "16px",
//                       }}
//                     >
//                       {row.heardAbout?.replace(/_/g, " ") || "N/A"}
//                     </TableCell>
//                     <TableCell>
//                       <Tooltip title={row.message || "No message"}>
//                         <Typography
//                           variant="body2"
//                           sx={{
//                             fontFamily: "Outfit",
//                             fontSize: "14px",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             whiteSpace: "nowrap",
//                             maxWidth: 200,
//                           }}
//                         >
//                           {row.message || "-"}
//                         </Typography>
//                       </Tooltip>
//                     </TableCell>
//                     <TableCell>
//                       <FormControl
//                         size="small"
//                         sx={{
//                           minWidth: 130,
//                           display: "flex",
//                           justifyContent: "center",
//                           alignItems: "center",
//                         }}
//                       >
//                         <Select
//                           value={row.status || "not_reached"}
//                           onChange={(e) =>
//                             handleStatusChange(row._id, e.target.value)
//                           }
//                           disabled={updateLoading[row._id]}
//                           displayEmpty
//                           sx={{
//                             height: 32,
//                             "& .MuiSelect-select": {
//                               padding: "4px 8px",
//                               display: "flex",
//                               alignItems: "center",
//                               fontFamily: "Outfit",
//                               justifyContent: "center",
//                               height: "auto",
//                             },
//                             "& .MuiOutlinedInput-notchedOutline": {
//                               border: "none !important",
//                             },
//                             "&:hover .MuiOutlinedInput-notchedOutline": {
//                               border: "none !important",
//                             },
//                             "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//                               border: "none !important",
//                             },
//                             "&.Mui-focused": {
//                               backgroundColor: "transparent",
//                             },
//                           }}
//                           MenuProps={{
//                             disablePortal: false,
//                             PaperProps: {
//                               sx: {
//                                 boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//                                 borderRadius: "8px",
//                                 border: "1px solid #e0e0e0",
//                                 mt: 0.5,
//                                 minWidth: 130,
//                                 maxHeight: 200,
//                                 overflow: "auto",
//                                 "& .MuiMenuItem-root": {
//                                   padding: "8px 12px",
//                                   minHeight: 36,
//                                   display: "flex",
//                                   justifyContent: "center",
//                                   alignItems: "center",
//                                   "&:hover": {
//                                     backgroundColor: "#f5f5f5",
//                                   },
//                                   "&.Mui-selected": {
//                                     backgroundColor: "#f3f0ff",
//                                     "&:hover": {
//                                       backgroundColor: "#e8dcff",
//                                     },
//                                   },
//                                 },
//                               },
//                             },
//                             anchorOrigin: {
//                               vertical: "bottom",
//                               horizontal: "left",
//                             },
//                             transformOrigin: {
//                               vertical: "top",
//                               horizontal: "left",
//                             },
//                           }}
//                         >
//                           <MenuItem value="reached">
//                             <Chip
//                               label="Reached"
//                               size="small"
//                               color="success"
//                               sx={{
//                                 fontSize: "14px",
//                                 height: 24,
//                                 minWidth: 90,
//                                 fontFamily: "Outfit",
//                                 padding: "0 8px",
//                               }}
//                             />
//                           </MenuItem>
//                           <MenuItem value="not_reached">
//                             <Chip
//                               label="Not Reached"
//                               size="small"
//                               color="error"
//                               sx={{
//                                 fontSize: "14px",
//                                 height: 24,
//                                 minWidth: 100,
//                                 fontFamily: "Outfit",
//                                 padding: "0 8px",
//                               }}
//                             />
//                           </MenuItem>
//                         </Select>
//                         {updateLoading[row._id] && (
//                           <CircularProgress
//                             size={16}
//                             sx={{
//                               position: "absolute",
//                               right: 8,
//                               top: "50%",
//                               transform: "translateY(-50%)",
//                             }}
//                           />
//                         )}
//                       </FormControl>
//                     </TableCell>
//                     <TableCell>
//                       <TextField
//                         multiline
//                         rows={1}
//                         value={row.notes || ""}
//                         onChange={(e) =>
//                           handleNotesChange(row._id, e.target.value)
//                         }
//                         placeholder="Add notes..."
//                         variant="outlined"
//                         size="small"
//                         disabled={updateLoading[row._id]}
//                         sx={{
//                           width: "100%",
//                           "& .MuiInputBase-root": {
//                             minHeight: "32px",
//                           },
//                           "& .MuiInputBase-input": {
//                             padding: "6px 8px",
//                             fontSize: "14px",
//                             fontFamily: "Outfit",
//                           },
//                         }}
//                       />
//                     </TableCell>
//                     <TableCell
//                       sx={{
//                         color: "#A3AED0",
//                         fontFamily: "Outfit",
//                         fontSize: "16px",
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       {formatDate(row.submittedAt || row.createdAt)}
//                     </TableCell>
//                     <TableCell sx={{ textAlign: "center" }}>
//                       <Tooltip title="Delete submission">
//                         <IconButton
//                           onClick={() =>
//                             handleDeleteClick(row._id, row.fullName)
//                           }
//                           disabled={deleteLoading[row._id]}
//                           sx={{
//                             color: "#f44336",
//                             "&:hover": {
//                               backgroundColor: "rgba(244, 67, 54, 0.1)",
//                             },
//                             "&:disabled": {
//                               color: "rgba(244, 67, 54, 0.3)",
//                             },
//                           }}
//                         >
//                           {deleteLoading[row._id] ? (
//                             <CircularProgress size={20} color="inherit" />
//                           ) : (
//                             <Delete />
//                           )}
//                         </IconButton>
//                       </Tooltip>
//                     </TableCell>
//                   </TableRow>
//                 ))
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </Paper>

//       {/* Pagination and Results Summary */}
//       <Box
//         sx={{
//           mt: 3,
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           flexDirection: { xs: "column", sm: "row" },
//           gap: { xs: 2, sm: 0 },
//         }}
//       >
//         <Typography
//           variant="body2"
//           color="text.secondary"
//           sx={{ fontFamily: "Outfit", fontSize: "16px" }}
//         >
//           Showing {sortedData.length} of {pagination.totalItems} entries
//           {searchTerm && ` (filtered by "${searchTerm}")`}
//         </Typography>

//         {pagination.totalPages > 1 && (
//           <Pagination
//             count={pagination.totalPages}
//             page={pagination.currentPage}
//             onChange={handlePageChange}
//             sx={{
//               "& .MuiPaginationItem-root": {
//                 color: "#9048FB",
//                 fontFamily: "Outfit",
//                 fontSize: "16px",
//                 "&.Mui-selected": {
//                   backgroundColor: "#9048FB",
//                   color: "white",
//                 },
//                 "&:hover": {
//                   backgroundColor: "#f3f0ff",
//                 },
//               },
//             }}
//             disabled={loading}
//           />
//         )}
//       </Box>

//       {/* Delete Confirmation Dialog */}
//       <Dialog
//         open={deleteDialog.open}
//         onClose={handleDeleteCancel}
//         aria-labelledby="delete-dialog-title"
//         aria-describedby="delete-dialog-description"
//       >
//         <DialogTitle
//           id="delete-dialog-title"
//           sx={{
//             fontFamily: "Outfit",
//             fontWeight: 600,
//             color: "#f44336",
//           }}
//         >
//           Confirm Delete
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText
//             id="delete-dialog-description"
//             sx={{
//               fontFamily: "Outfit",
//               fontSize: "16px",
//             }}
//           >
//             Are you sure you want to delete the contact submission from{" "}
//             <strong>{deleteDialog.submissionName}</strong>? This action cannot
//             be undone.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions sx={{ p: 2, gap: 1 }}>
//           <Button
//             onClick={handleDeleteCancel}
//             sx={{
//               fontFamily: "Outfit",
//               color: "#666",
//               "&:hover": {
//                 backgroundColor: "#f5f5f5",
//               },
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleDeleteConfirm}
//             variant="contained"
//             sx={{
//               fontFamily: "Outfit",
//               backgroundColor: "#f44336",
//               "&:hover": {
//                 backgroundColor: "#d32f2f",
//               },
//             }}
//           >
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Success/Error Snackbar */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={snackbar.severity}
//           sx={{
//             width: "100%",
//             fontFamily: "Outfit",
//             fontSize: "16px",
//           }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default DataTable;
import React, { useState, useMemo, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Box,
  Typography,
  IconButton,
  TableSortLabel,
  Chip,
  Select,
  MenuItem,
  FormControl,
  CircularProgress,
  Alert,
  Pagination,
  Snackbar,
  InputAdornment,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Tooltip,
} from "@mui/material";
import {
  Search,
  ArrowUpward,
  ArrowDownward,
  Refresh,
  Delete,
} from "@mui/icons-material";

const API_BASE_URL = `${process.env.REACT_APP_SUPERADMIN_APP_API_BASE_URL}/api`;

const DataTable = ({ sidebarOpen = true }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  });
  const [updateLoading, setUpdateLoading] = useState({});
  const [deleteLoading, setDeleteLoading] = useState({});
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    submissionId: null,
    submissionName: "",
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // Fetch data from API
  const fetchData = async (page = 1, search = "", limit = 10) => {
    try {
      setLoading(true);
      setError(null);

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        sortOrder: sortOrder, // ✅ Send sortOrder to backend
        ...(search && { search }),
      });

      const response = await fetch(
        `${API_BASE_URL}/contact-submissions?${queryParams}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        setData(result.data.submissions);
        setPagination(result.data.pagination);
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(`Failed to load data: ${err.message}`);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  // Update contact submission
  const updateContactSubmission = async (id, updates) => {
    try {
      setUpdateLoading((prev) => ({ ...prev, [id]: true }));

      const response = await fetch(
        `${API_BASE_URL}/contact-submissions/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updates),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        // Update local state
        setData((prevData) =>
          prevData.map((item) =>
            item._id === id ? { ...item, ...updates } : item
          )
        );

        setSnackbar({
          open: true,
          message: "Updated successfully",
          severity: "success",
        });
      } else {
        throw new Error(result.message || "Failed to update");
      }
    } catch (err) {
      console.error("Error updating contact submission:", err);
      setSnackbar({
        open: true,
        message: `Update failed: ${err.message}`,
        severity: "error",
      });
    } finally {
      setUpdateLoading((prev) => ({ ...prev, [id]: false }));
    }
  };

  // Delete contact submission
  const deleteContactSubmission = async (id) => {
    try {
      setDeleteLoading((prev) => ({ ...prev, [id]: true }));

      const response = await fetch(
        `${API_BASE_URL}/contact-submissions/${id}`,
        {
          method: "DELETE",
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        // Remove from local state
        setData((prevData) => prevData.filter((item) => item._id !== id));

        // Update pagination
        setPagination((prev) => ({
          ...prev,
          totalItems: prev.totalItems - 1,
        }));

        setSnackbar({
          open: true,
          message: "Contact submission deleted successfully",
          severity: "success",
        });

        // If current page becomes empty, go to previous page
        if (data.length === 1 && pagination.currentPage > 1) {
          fetchData(
            pagination.currentPage - 1,
            searchTerm,
            pagination.itemsPerPage
          );
        }
      } else {
        throw new Error(result.message || "Failed to delete");
      }
    } catch (err) {
      console.error("Error deleting contact submission:", err);
      setSnackbar({
        open: true,
        message: `Delete failed: ${err.message}`,
        severity: "error",
      });
    } finally {
      setDeleteLoading((prev) => ({ ...prev, [id]: false }));
      setDeleteDialog({ open: false, submissionId: null, submissionName: "" });
    }
  };

  // Handle delete click
  const handleDeleteClick = (id, name) => {
    setDeleteDialog({
      open: true,
      submissionId: id,
      submissionName: name,
    });
  };

  // Handle delete confirm
  const handleDeleteConfirm = () => {
    if (deleteDialog.submissionId) {
      deleteContactSubmission(deleteDialog.submissionId);
    }
  };

  // Handle delete cancel
  const handleDeleteCancel = () => {
    setDeleteDialog({ open: false, submissionId: null, submissionName: "" });
  };

  // Initial data load
  useEffect(() => {
    fetchData();
  }, []);

  // ✅ Refetch data when sortOrder changes
  useEffect(() => {
    if (pagination.currentPage) {
      fetchData(pagination.currentPage, searchTerm, pagination.itemsPerPage);
    }
  }, [sortOrder]);

  // Handle search with debounce
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchData(1, searchTerm, pagination.itemsPerPage);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  // Handle page change
  const handlePageChange = (event, newPage) => {
    fetchData(newPage, searchTerm, pagination.itemsPerPage);
  };

  // Handle refresh
  const handleRefresh = () => {
    fetchData(pagination.currentPage, searchTerm, pagination.itemsPerPage);
  };

  // Handle status change with API call
  const handleStatusChange = async (id, newStatus) => {
    await updateContactSubmission(id, { status: newStatus });
  };

  // Handle notes change with API call (debounced)
  const handleNotesChange = (id, newNotes) => {
    // Update local state immediately for better UX
    setData((prevData) =>
      prevData.map((item) =>
        item._id === id ? { ...item, notes: newNotes } : item
      )
    );

    // Debounce API call
    clearTimeout(window[`notesTimeout_${id}`]);
    window[`notesTimeout_${id}`] = setTimeout(() => {
      updateContactSubmission(id, { notes: newNotes });
    }, 1000); // 1 second delay
  };

  // ✅ No need for local sorting - backend handles it now
  // Just display the data as received from backend
  const sortedData = useMemo(() => {
    return data; // Backend already sorted
  }, [data]);

  const handleSortChange = () => {
    setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const formatStepList = (value) => {
    if (!value) return "-";
    if (Array.isArray(value)) return value.filter(Boolean).join(", ") || "-";
    return String(value);
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // Calculate sidebar width based on state
  const sidebarWidth = sidebarOpen ? 220 : 100;

  if (loading && data.length === 0) {
    return (
      <Box
        sx={{
          p: 4,
          ml: {
            xs: "0px",
            sm: "0px",
            md: `${sidebarWidth}px`,
            xl: `${sidebarWidth}px`,
          },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        p: 4,
        backgroundColor: "#fafafa",
        minHeight: "100vh",
        ml: {
          xs: "0px",
          sm: "0px",
          md: `${sidebarWidth}px`,
          xl: `${sidebarWidth}px`,
        },
        transition: "margin-left 0.3s ease",
        fontFamily: "Outfit",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: "#9048FB",
            fontWeight: 600,
            fontFamily: "Outfit",
          }}
        >
          Contact Submissions
        </Typography>
        <IconButton
          onClick={handleRefresh}
          disabled={loading}
          sx={{
            bgcolor: "#9048FB",
            color: "white",
            "&:hover": { bgcolor: "#7c3aed" },
          }}
        >
          <Refresh />
        </IconButton>
      </Box>

      {/* Error Alert */}
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      {/* Search and Sort Controls */}
      <Box
        sx={{
          display: "flex",
          gap: 2,
          mb: 3,
          alignItems: "center",
          flexDirection: { xs: "column", sm: "row" },
        }}
      >
        <TextField
          variant="outlined"
          placeholder="Search by name, email, or company..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          disabled={loading}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
          sx={{
            flexGrow: 1,
            maxWidth: 400,
            backgroundColor: "white",
            "& .MuiInputBase-input": {
              fontFamily: "Outfit",
              fontSize: "16px",
            },
          }}
        />

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontFamily: "Outfit" }}
          >
            Sort:
          </Typography>
          <IconButton
            onClick={handleSortChange}
            sx={{
              bgcolor: "#9048FB",
              color: "white",
              "&:hover": { bgcolor: "#7c3aed" },
            }}
          >
            {sortOrder === "desc" ? <ArrowDownward /> : <ArrowUpward />}
          </IconButton>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontFamily: "Outfit" }}
          >
            {sortOrder === "desc" ? "Newest" : "Oldest"}
          </Typography>
        </Box>
      </Box>

      {/* Data Table */}
      <Paper sx={{ overflow: "hidden", boxShadow: 2 }}>
        <TableContainer
          sx={{
            position: "relative",
            maxHeight: 700,
            overflow: "auto",
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#c1c1c1",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "#a1a1a1",
            },
          }}
        >
          {loading && (
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "rgba(255, 255, 255, 0.8)",
                zIndex: 1,
              }}
            >
              <CircularProgress />
            </Box>
          )}

          <Table sx={{ minWidth: 1200 }}>
            <TableHead sx={{ bgcolor: "#9048FB" }}>
              <TableRow>
                <TableCell
                  sx={{
                    color: "white",
                    fontWeight: 600,
                    fontFamily: "Outfit",
                    fontSize: "16px",
                    minWidth: 120,
                    whiteSpace: "nowrap",
                    position: "sticky",
                    left: 0,
                    zIndex: 3, // above sticky header + body cells
                    bgcolor: "#9048FB",
                  }}
                >
                  Full Name
                </TableCell>
                <TableCell
                  sx={{
                    color: "white",
                    fontWeight: 600,
                    fontFamily: "Outfit",
                    fontSize: "16px",
                    minWidth: 180,
                    whiteSpace: "nowrap",
                  }}
                >
                  Work Email
                </TableCell>
                <TableCell sx={{ color: "white", fontWeight: 600, fontFamily: "Outfit", fontSize: "16px", minWidth: 240, whiteSpace: "nowrap" }}>
                  Step 2: Hiring blockers
                </TableCell>
                <TableCell sx={{ color: "white", fontWeight: 600, fontFamily: "Outfit", fontSize: "16px", minWidth: 170, whiteSpace: "nowrap" }}>
                  Step 3: Monthly hires
                </TableCell>
                <TableCell sx={{ color: "white", fontWeight: 600, fontFamily: "Outfit", fontSize: "16px", minWidth: 220, whiteSpace: "nowrap" }}>
                  Step 4: Sourcing today
                </TableCell>
                <TableCell sx={{ color: "white", fontWeight: 600, fontFamily: "Outfit", fontSize: "16px", minWidth: 240, whiteSpace: "nowrap" }}>
                  Step 5: Screening today
                </TableCell>
                <TableCell sx={{ color: "white", fontWeight: 600, fontFamily: "Outfit", fontSize: "16px", minWidth: 190, whiteSpace: "nowrap" }}>
                  Step 6: Value
                </TableCell>
                <TableCell sx={{ color: "white", fontWeight: 600, fontFamily: "Outfit", fontSize: "16px", minWidth: 190, whiteSpace: "nowrap" }}>
                  Step 7: Urgency
                </TableCell>
                <TableCell sx={{ color: "white", fontWeight: 600, fontFamily: "Outfit", fontSize: "16px", minWidth: 140, whiteSpace: "nowrap" }}>
                  Submitted
                </TableCell>
                <TableCell sx={{ color: "white", fontWeight: 600, fontFamily: "Outfit", fontSize: "16px", minWidth: 150, whiteSpace: "nowrap" }}>
                  Meeting booked?
                </TableCell>
                <TableCell
                  sx={{
                    color: "white",
                    fontWeight: 600,
                    fontFamily: "Outfit",
                    fontSize: "16px",
                    minWidth: 120,
                    whiteSpace: "nowrap",
                  }}
                >
                  Status
                </TableCell>
                <TableCell
                  sx={{
                    color: "white",
                    fontWeight: 600,
                    minWidth: 180,
                    fontFamily: "Outfit",
                    fontSize: "16px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Notes
                </TableCell>
                <TableCell
                  sx={{
                    color: "white",
                    fontWeight: 600,
                    fontFamily: "Outfit",
                    fontSize: "16px",
                    minWidth: 120,
                    whiteSpace: "nowrap",
                  }}
                >
                  <TableSortLabel
                    active={true}
                    direction={sortOrder}
                    onClick={handleSortChange}
                    sx={{
                      color: "white !important",
                      fontFamily: "Outfit",
                      "& .MuiTableSortLabel-icon": {
                        color: "white !important",
                      },
                    }}
                  >
                    Date (Created)
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sx={{
                    color: "white",
                    fontWeight: 600,
                    fontFamily: "Outfit",
                    fontSize: "16px",
                    minWidth: 80,
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedData.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={14}
                    sx={{
                      textAlign: "center",
                      py: 4,
                      color: "text.secondary",
                      fontFamily: "Outfit",
                      fontSize: "16px",
                    }}
                  >
                    {searchTerm ? "No results found" : "No data available"}
                  </TableCell>
                </TableRow>
              ) : (
                sortedData.map((row) => (
                  <TableRow
                    key={row._id}
                    sx={{
                      "&:nth-of-type(even)": {
                        bgcolor: "#f5f5f5",
                      },
                      "&:hover": {
                        bgcolor: "#f3f0ff",
                      },
                    }}
                  >
                    <TableCell
                      sx={{
                        fontWeight: 500,
                        fontFamily: "Outfit",
                        fontSize: "16px",
                        position: "sticky",
                        left: 0,
                        zIndex: 2,
                        bgcolor: "white",
                        "&::after": {
                          content: '""',
                          position: "absolute",
                          top: 0,
                          right: 0,
                          width: "1px",
                          height: "100%",
                          backgroundColor: "#E5E7EB",
                        },
                      }}
                    >
                      {row.firstName || row.fullName || "-"}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#9048FB",
                        fontFamily: "Outfit",
                        fontSize: "16px",
                      }}
                    >
                      {row.email || row.workEmail || "-"}
                    </TableCell>
                    <TableCell>
                      <Tooltip title={formatStepList(row.step2)}>
                        <Typography variant="body2" sx={{ fontFamily: "Outfit", fontSize: "14px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 240 }}>
                          {formatStepList(row.step2)}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Tooltip title={formatStepList(row.step3)}>
                        <Typography variant="body2" sx={{ fontFamily: "Outfit", fontSize: "14px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 170 }}>
                          {formatStepList(row.step3)}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Tooltip title={formatStepList(row.step4)}>
                        <Typography variant="body2" sx={{ fontFamily: "Outfit", fontSize: "14px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 220 }}>
                          {formatStepList(row.step4)}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Tooltip title={formatStepList(row.step5)}>
                        <Typography variant="body2" sx={{ fontFamily: "Outfit", fontSize: "14px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 240 }}>
                          {formatStepList(row.step5)}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Tooltip title={formatStepList(row.step6)}>
                        <Typography variant="body2" sx={{ fontFamily: "Outfit", fontSize: "14px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 190 }}>
                          {formatStepList(row.step6)}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Tooltip title={formatStepList(row.step7)}>
                        <Typography variant="body2" sx={{ fontFamily: "Outfit", fontSize: "14px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 190 }}>
                          {formatStepList(row.step7)}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell sx={{ color: "#A3AED0", fontFamily: "Outfit", fontSize: "16px", whiteSpace: "nowrap" }}>
                      {formatDate(row.formSubmittedAt || row.submittedAt)}
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={row.meetingBooked ? "Yes" : "No"}
                        size="small"
                        color={row.meetingBooked ? "success" : "default"}
                        sx={{
                          fontFamily: "Outfit",
                          fontSize: "14px",
                          ...(row.meetingBooked
                            ? {}
                            : { backgroundColor: "#E5E7EB", color: "#111827" }),
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <FormControl
                        size="small"
                        sx={{
                          minWidth: 130,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Select
                          value={row.status || "not_reached"}
                          onChange={(e) =>
                            handleStatusChange(row._id, e.target.value)
                          }
                          disabled={updateLoading[row._id]}
                          displayEmpty
                          sx={{
                            height: 32,
                            "& .MuiSelect-select": {
                              padding: "4px 8px",
                              display: "flex",
                              alignItems: "center",
                              fontFamily: "Outfit",
                              justifyContent: "center",
                              height: "auto",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              border: "none !important",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              border: "none !important",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              border: "none !important",
                            },
                            "&.Mui-focused": {
                              backgroundColor: "transparent",
                            },
                          }}
                          MenuProps={{
                            disablePortal: false,
                            PaperProps: {
                              sx: {
                                boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                                borderRadius: "8px",
                                border: "1px solid #e0e0e0",
                                mt: 0.5,
                                minWidth: 130,
                                maxHeight: 200,
                                overflow: "auto",
                                "& .MuiMenuItem-root": {
                                  padding: "8px 12px",
                                  minHeight: 36,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  "&:hover": {
                                    backgroundColor: "#f5f5f5",
                                  },
                                  "&.Mui-selected": {
                                    backgroundColor: "#f3f0ff",
                                    "&:hover": {
                                      backgroundColor: "#e8dcff",
                                    },
                                  },
                                },
                              },
                            },
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left",
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left",
                            },
                          }}
                        >
                          <MenuItem value="reached">
                            <Chip
                              label="Reached"
                              size="small"
                              color="success"
                              sx={{
                                fontSize: "14px",
                                height: 24,
                                minWidth: 90,
                                fontFamily: "Outfit",
                                padding: "0 8px",
                              }}
                            />
                          </MenuItem>
                          <MenuItem value="not_reached">
                            <Chip
                              label="Not Reached"
                              size="small"
                              color="error"
                              sx={{
                                fontSize: "14px",
                                height: 24,
                                minWidth: 100,
                                fontFamily: "Outfit",
                                padding: "0 8px",
                              }}
                            />
                          </MenuItem>
                        </Select>
                        {updateLoading[row._id] && (
                          <CircularProgress
                            size={16}
                            sx={{
                              position: "absolute",
                              right: 8,
                              top: "50%",
                              transform: "translateY(-50%)",
                            }}
                          />
                        )}
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <TextField
                        multiline
                        rows={1}
                        value={row.notes || ""}
                        onChange={(e) =>
                          handleNotesChange(row._id, e.target.value)
                        }
                        placeholder="Add notes..."
                        variant="outlined"
                        size="small"
                        disabled={updateLoading[row._id]}
                        sx={{
                          width: "100%",
                          "& .MuiInputBase-root": {
                            minHeight: "32px",
                          },
                          "& .MuiInputBase-input": {
                            padding: "6px 8px",
                            fontSize: "14px",
                            fontFamily: "Outfit",
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#A3AED0",
                        fontFamily: "Outfit",
                        fontSize: "16px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {formatDate(row.createdAt)}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      <Tooltip title="Delete submission">
                        <IconButton
                          onClick={() =>
                            handleDeleteClick(row._id, row.fullName)
                          }
                          disabled={deleteLoading[row._id]}
                          sx={{
                            color: "#f44336",
                            "&:hover": {
                              backgroundColor: "rgba(244, 67, 54, 0.1)",
                            },
                            "&:disabled": {
                              color: "rgba(244, 67, 54, 0.3)",
                            },
                          }}
                        >
                          {deleteLoading[row._id] ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : (
                            <Delete />
                          )}
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Pagination and Results Summary */}
      <Box
        sx={{
          mt: 3,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 2, sm: 0 },
        }}
      >
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontFamily: "Outfit", fontSize: "16px" }}
        >
          Showing {sortedData.length} of {pagination.totalItems} entries
          {searchTerm && ` (filtered by "${searchTerm}")`}
        </Typography>

        {pagination.totalPages > 1 && (
          <Pagination
            count={pagination.totalPages}
            page={pagination.currentPage}
            onChange={handlePageChange}
            sx={{
              "& .MuiPaginationItem-root": {
                color: "#9048FB",
                fontFamily: "Outfit",
                fontSize: "16px",
                "&.Mui-selected": {
                  backgroundColor: "#9048FB",
                  color: "white",
                },
                "&:hover": {
                  backgroundColor: "#f3f0ff",
                },
              },
            }}
            disabled={loading}
          />
        )}
      </Box>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialog.open}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle
          id="delete-dialog-title"
          sx={{
            fontFamily: "Outfit",
            fontWeight: 600,
            color: "#f44336",
          }}
        >
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="delete-dialog-description"
            sx={{
              fontFamily: "Outfit",
              fontSize: "16px",
            }}
          >
            Are you sure you want to delete the contact submission from{" "}
            <strong>{deleteDialog.submissionName}</strong>? This action cannot
            be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={handleDeleteCancel}
            sx={{
              fontFamily: "Outfit",
              color: "#666",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteConfirm}
            variant="contained"
            sx={{
              fontFamily: "Outfit",
              backgroundColor: "#f44336",
              "&:hover": {
                backgroundColor: "#d32f2f",
              },
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Success/Error Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{
            width: "100%",
            fontFamily: "Outfit",
            fontSize: "16px",
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default DataTable;
